import { useNavigate } from "react-router-dom";
import { useApp } from "../lib/store";
import { Button } from "../components/ui/button";
import { Cable, Map } from "lucide-react";

export default function InterfaceMonitor() {
  const { t } = useApp();
  const navigate = useNavigate();
  return (
    <div className="space-y-4" data-testid="interface-monitor-page">
      <h1 className="text-3xl font-bold tracking-tight text-gray-900" style={{ fontFamily: "Work Sans" }}>{t("interface_monitor")}</h1>
      <div className="bg-white border border-gray-200 rounded-xl p-12 text-center max-w-2xl">
        <div className="h-14 w-14 rounded-2xl bg-[#1B2A4A] flex items-center justify-center mx-auto mb-4">
          <Cable className="h-7 w-7 text-[#F5A623]" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">{t("monitor_phase3_title")}</h2>
        <p className="text-sm text-gray-500 mt-2 max-w-md mx-auto">{t("monitor_phase3_desc")}</p>
        <Button variant="outline" className="mt-5" onClick={() => navigate("/roadmap")} data-testid="monitor-roadmap-btn">
          <Map className="h-4 w-4 mr-1.5" />{t("roadmap")}
        </Button>
      </div>
    </div>
  );
}
